module.exports = __webpack_public_path__ + "img/henson-for-iowa-header-1.cdb44153.svg";